import _get from 'lodash/get';

import { SHOW_TOASTER, RESET_TOASTER } from './constants';

export const showToaster = (payload) => ({
  type: SHOW_TOASTER,
  data: payload,
});

export const resetToaster = (payload) => ({
  type: RESET_TOASTER,
  data: payload,
});

export const getToasterInfo = (state) => _get(state, 'toaster', {});
